import { c as _c } from "react/compiler-runtime";
import { useSubscribedCouponCollection } from './useSubscribedCouponCollection.js';
/**
 * Subscribes to selected changes for a given coupon.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @param root0.selector State selector
 * @returns selected value
 */
export function useSubscribedCoupon(t0) {
  const $ = _c(6);
  const {
    couponId,
    couponIndex,
    selector
  } = t0;
  let t1;
  if ($[0] !== couponIndex || $[1] !== selector) {
    t1 = couponCollection => selector(couponCollection?.[couponIndex]);
    $[0] = couponIndex;
    $[1] = selector;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== couponId || $[4] !== t1) {
    t2 = {
      couponId,
      selector: t1
    };
    $[3] = couponId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useSubscribedCouponCollection(t2);
}